/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CardProductionLastCardByCardTypeQuery = {
    /**
     * Card production cards type. "EMPLOYEE", "EXPRESS" etc
     */
    productionCardType: CardProductionLastCardByCardTypeQuery.productionCardType;
};
export namespace CardProductionLastCardByCardTypeQuery {
    /**
     * Card production cards type. "EMPLOYEE", "EXPRESS" etc
     */
    export enum productionCardType {
        PERSONAL = 'PERSONAL',
        EXPRESS = 'EXPRESS',
        PORTABLE = 'PORTABLE',
        RECLAMATION = 'RECLAMATION',
        EMPLOYEE = 'EMPLOYEE',
    }
}

